import React, { useState } from 'react';
import FastAPIClient from '../services/apiClient';
import { useLocation, useNavigate } from 'react-router-dom';
import Input from '../components/ui/Input';
import { checkpointOrganizations } from '../apiHelper';

// Instantiating outside the component prevents creating a new instance on every render
const apiClient = new FastAPIClient();

// Login Page Component
const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState('');
    const [isAuthenticating, setIsAuthenticating] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const navigate = useNavigate();
    const location = useLocation();

    const [showPassword, setShowPassword] = useState(false);
    const [selectedOrgId, setSelectedOrgId] = useState(null);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoginError('');
        // setSuccessMessage('');
        // setIsAuthenticating(true);

        if (!email || !password) {
            setLoginError('Please enter both email and password.');
            setIsAuthenticating(false);
            return;
        }

        try {
            const orgsResponse = await checkpointOrganizations(email);
            // console.log(orgsResponse)
            if(orgsResponse && orgsResponse.length == 1) {
                setSelectedOrgId(orgsResponse[0].organization_id)
            }
            await performLogin(orgsResponse[0]?.organization_id);
        } catch (error) {
            setLoginError(error.respose?.data?.detail || 'Failed to determine host organization.');
        }
    };

    const performLogin = async (orgId = null) => {
        setLoginError('');
        setSuccessMessage('');
        setIsAuthenticating(true);

        try {
            if (orgId) {
                localStorage.setItem('org_id', orgId);
            }
            const user = await apiClient.login(
                email,
                password
            );
            // console.log(user)
            setSuccessMessage(user.data.msg);
            setTimeout(() => {
                const lcUser = localStorage.getItem("user");
                navigate("/login-verification",  { state: {...JSON.parse(lcUser) } });
            }, 800);
        } catch (error) {
            localStorage.removeItem('org_id');
            setLoginError(error.response?.data?.detail || error.response?.data?.message || error.message || 'An unexpected error occurred during login.');
        } finally {
            setIsAuthenticating(false);
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
            <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-xl transform transition-all duration-300 ease-in-out hover:scale-[1.005]">
                <div className="flex justify-center mb-6">
                    <img
                        src="/logo.png"
                        alt="School Logo"
                        className="h-20"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://placehold.co/80x80/0000FF/FFFFFF?text=Logo';
                        }}
                    />
                </div>
                <h2 className="text-3xl font-bold text-center mb-6 text-slate-800">
                    School Payments <span className="text-blue-900">Login</span>
                </h2>
                <form onSubmit={handleLogin} className="space-y-5">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium mb-1 text-slate-600">
                            Email Address
                        </label>
                        <Input
                            id="email"
                            type="email"
                            className="w-full p-3 border border-slate-300 rounded-md outline-none transition-all duration-200 focus:ring-1 focus:ring-blue-900"
                            placeholder="e.g., parent@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={isAuthenticating}
                        />
                        {/* <input
                            type="email"
                            id="email"
                            className="w-full p-3 border border-slate-300 rounded-md outline-none transition-all duration-200 focus:border-blue-900 focus:ring-1 focus:ring-blue-900"
                            placeholder="parent@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={isAuthenticating}
                        /> */}
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium mb-1 text-slate-600">
                            Password
                        </label>
                        <Input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            className="w-full p-3 border border-slate-300 rounded-md outline-none transition-all duration-200 focus:ring-1 focus:ring-blue-900"
                            placeholder="enter password..."
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isAuthenticating} 
                            trailingIcon={
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="text-gray-500 hover:text-gray-700 focus:outline-none pointer-events-auto"
                                    aria-label={showPassword ? "Hide Password" : "Show Password"}
                                >
                                    {showPassword ? (
                                        // Eye slashed (hidden)
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                            <path d="M1 1l22 22" />
                                        </svg>
                                    ) : (
                                        // Eye open (visible)
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    )}
                                </button>
                            }
                        />
                        {/* <input
                            type="password"
                            id="password"
                            className="w-full p-3 border border-slate-300 rounded-md outline-none transition-all duration-200 focus:border-blue-900 focus:ring-1 focus:ring-blue-900"
                            placeholder="password123"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isAuthenticating}
                        /> */}
                    </div>
                    {loginError && (
                        <p className="text-red-500 text-sm text-center">{loginError}</p>
                    )}
                    {successMessage && (
                        <p className="text-gmail-green text-sm text-center mb-4">{successMessage}</p>
                    )}
                    <button
                        type="submit"
                        className="w-full py-3 px-4 rounded-md font-semibold text-white bg-blue-900 hover:bg-blue-800 active:bg-blue-950 transition-all duration-200 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:transform-none"
                        disabled={isAuthenticating}
                    >
                        {isAuthenticating ? 'Logging In...' : 'Log In'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;